import { useCallback } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { currentRmaState, authenticationState, lookupState, accountState } from 'state/atoms';
import { defaultCheckoutState, defaultCurrentRmaState, defaultLookupState } from 'state/defaults';
import { storageCheckoutSelector, storageCurrentRmaSelector } from 'state/selectors';

export function useRmaItemController() {
  const { endCustomerAccountId } = useRecoilValue(authenticationState);
  const currentState = useRecoilValue(currentRmaState);
  const account = useRecoilValue(accountState);
  const setCurrentState = useSetRecoilState(storageCurrentRmaSelector);
  const setCurrentRma = useSetRecoilState(storageCurrentRmaSelector);
  const setCheckout = useSetRecoilState(storageCheckoutSelector);
  const setLookupState = useSetRecoilState(lookupState);

  const resetRma = useCallback(() => {
    setCurrentRma({ ...defaultCurrentRmaState, currencyCode: account.defaultCurrencyCode });
    setCheckout(defaultCheckoutState);
    setLookupState(defaultLookupState);
  }, [account, setCheckout, setCurrentRma, setLookupState]);

  const removeItem = (serialNumber) => {
    setCurrentState({
      ...currentState,
      accountId: endCustomerAccountId,
      items: currentState.items.filter((item) => item.serialNumber !== serialNumber),
    });
  };

  return { removeItem, resetRma };
}
